import React, { useState } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';

const useStyles = makeStyles(theme => ({
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
}))
function RSS() {
    const classes = useStyles();
    const translate = useTranslate();
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { URL, updateFrequency } = nodeSelected.applicationData.nodeApplication.Rss;

    const onChangeTextValue = prop => event => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                Rss: {
                    ...nodeSelected.applicationData.nodeApplication.Rss,
                    [prop]: event.target.value
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }
    return (
        <Box>
            <Box mt={3.5}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('pos.categories.url')}
                    value={URL}
                    onChange={onChangeTextValue('URL')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`resources.infoPage.rss_application.url`)}
                        content={translate(`resources.infoPage.rss_application.url_content`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box mt={2}>
                <OneLineTextField
                    disabled={!isEditing}
                    className={classes.number}
                    type='number'
                    id="filled-basic"
                    label={translate(`pos.common.updateFrequency`)}
                    value={updateFrequency}
                    onChange={onChangeTextValue('updateFrequency')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`resources.infoPage.rss_application.updateFrequency`)}
                        content={translate(`resources.infoPage.rss_application.updateFrequency_content`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
        </Box>
    )
}

export default RSS;
